import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import languagesPropType from '../languagesPropType.js';
import styles from './styles.css';
import translate from './translate.js';

const SuccessPanel = ({
  language,
}) => (
  <Grid
    className={styles.grid}
    fluid
    style={{
      height: '200px',
    }}
  >
    <Row style={{textAlign: 'center'}}>
      <Col xs={12}>
        <span style={{fontSize: '18px'}}>{translate('passwordWasReset', language)}</span>
      </Col>
    </Row>

    <Row style={{marginTop: '20px', textAlign: 'center'}}>
      <Col xs={12}>
        <div style={{fontSize: '16px', fontWeight: 400}}>{translate('updateClients', language)}</div>
      </Col>
    </Row>
  </Grid>
);

SuccessPanel.defaultProps = {
  language: languagesPropType.defaultProp,
};

SuccessPanel.propTypes = {
  language: languagesPropType.propType,
};

export default SuccessPanel;
